module.exports = __webpack_public_path__ + "img/Connected Gateway.1c1af2f9.png";